import request from '@/utils/request'

// 获取错题统计数据（仅错题范围）
export function getWrongbookStatistics(params) {
  return request({
    url: '/api/wrongbook/statistics',
    method: 'get',
    params
  })
}

// 获取错题关联的题目数据（仅错题范围）
export function getWrongbookQuestions(params) {
  return request({
    url: '/api/wrongbook/questions',
    method: 'get',
    params
  })
}

